import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation"; // Optional: For navigation buttons
import "swiper/css/pagination"; // Optional: For pagination
import { Navigation, Pagination } from "swiper/modules"; // Import modules
import "./Slider.css";
import { useRef, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

const Slider = ({
  sliderData,
  Component,
  handleClick,
  sliderHeight = 250,
  slidesPerView = 1,
  activeCard,
  activeSlide,
  sliderOnClick,
}) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  return (
    <>
      <div className="d-flex justify-content-end mb-5 ">
        <button
          ref={prevRef}
          disabled={isBeginning}
          className="customLeftArrow"
          style={{ background: isBeginning ? "#224B99" : "" }}
        >
          <KeyboardArrowLeftIcon
            sx={{ color: isBeginning ? "#ffffff" : "#224B99" }}
          />
        </button>
        <button
          ref={nextRef}
          disabled={isEnd}
          className="mx-2 customLeftArrow"
          style={{ background: isEnd ? "#224B99" : "" }}
        >
          <KeyboardArrowRightIcon
            sx={{ color: isEnd ? "#ffffff" : "#224B99" }}
          />
        </button>
      </div>
      <Swiper
        spaceBetween={30} // Space between slides
        slidesPerView={slidesPerView} // Number of slides visible at a time
        pagination={{ clickable: true }} // Enables pagination dots
        modules={[Navigation]} // Use Swiper modules
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onSwiper={(swiper) => {
          setTimeout(() => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          });
        }}
        onSlideChange={(swiper) => {
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
      >
        {sliderData.map((ele, index) => {
          return (
            <SwiperSlide
              key={ele?.userGroupId ?? index}
              style={{
                border: activeSlide === index ? "1px solid blue" : "",
                background: activeSlide === index ? "" : "#f1f5f9",
                borderRadius: "8px",
              }}
              onClick={() => {
                sliderOnClick(index);
              }}
            >
              <Component
                programDetails={ele}
                handleClick={handleClick}
                activeCard={activeCard}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default Slider;
